import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
// import SignatureCanvas from "react-signature-canvas";

import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';




import {
    KeyboardDatePicker,
    MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import PropTypes from 'prop-types';
import './style1.css';
import axios from 'axios';
import './style.scss';
import user from '../user.svg';
import bank from '../mansabank.png';
import { Input } from '@material-ui/core';
import { Label } from 'reactstrap';
import Bottomstrip from './Bottomstrip';
function calculate_age(dob) {
    var diff_ms = Date.now() - dob.getTime();
    var age_dt = new Date(diff_ms);
    return parseInt(Math.abs(age_dt.getUTCFullYear() - 1970));
}

function handleChange() {

}
const filterOptions = createFilterOptions({
    matchFrom: 'start',
    stringify: option => option,
});
        

    

    const myOptions = ['ABERCROMBIE','ALBION','ALLEE BRILLANT','ALMA','AMAURY','ANSE JONCHEE','ANSE LARAIE','ARGY','ARSENAL','BAIE DU CAP','BAIE DU TOMBEAU','BAIN BOEUF','BAIN DES DAME','BAIN DES DAMES CASSIS','BALACLAVA','BALISSON,ROSE BELLE','BAMBOUS','BAMBOUS VERIEUX','BANANES','BAR LE DUC VERDUN','BARKLY','BARLOW','BATIMARAIS','BATTIE GRAND GAUBE','BEAU BASSIN','BEAU PLAN','BEAU SONGES','BEAU VALLON','BEL AIR RIVIERE SECHE','BEL OMBRE','BELLE RIVE','BELLE TERRE','BELLE TERRE PHOENIX','BELLE VUE MAUREL','BELLE-MARE','BELVEDERE','BLACK RIVER','BLUE BAY','BOIS CHERI','BOIS MANGUE','BON ACCUEIL','BONNE TERRE','BORD CASCADES','BORSTAL','BOULET ROUGE','BRAMSTHAN','BRISEE VERDIERE','BRITANNIA','CALODYNE','CAMP  LA BOUE','CAMP CAVAL','CAMP CHAPELON','CAMP DE MASQUE, PAVE','CAMP DE MASQUE, UNITE','CAMP DE MASQUE, MEDINE','CAMP DES EMBREVADES','CAMP DES PECHEURS','CAMP DIABLE','CAMP FOUQUEREAUX','CAMP ITHIER','CAMP THOREL','CAMP YOLOFF','CANDOS','CANOT','CAP MALHEUREUX','CAROLINE','CARREAU ACCACIA','CASCAVELLE','CASE NOYALE','CASELA','CASSIS','CASTEL','CAUDAN WATERFRONT','CENTRE DE FLACQ','CHAMAREL','CHAMOUNY','CHAMP CHAPELON','CHAMPS DE MARS','CHATEAU BENARES','CHEBEL','CHEMIN GRENIER','CIRCONSTANCE , ST PIERRE','CITE  RIAMBEL','CITE ABERCROMBIE','CITE ATLEE FOREST SIDE','CITE BALISSON','CITE BARKLY','CITE KENNEDY, QUATRE BORNES','CITE L OISEAU, ALLEE BRILLANT','CITE LA CAVERNE, VACOAS','CITE LA FERME, BAMBOUS','CITE LOISEAU, FLOREAL','CITE MALHERBES, CUREPIPE','CITE MANGALKHAN, FLOREAL','CITE MARTIAL, PORT LOUIS','CITE MAUVILLAC, PAILLES','CITE RICHE LIEU','CITE ROCHE BOIS','CITE SAINTE CLAIR, GOODLANDS','CITE TREFLES, ROSE HILL','CITE VALLIJEE, PORT LOUIS','CITE VALLIJEE, CASSIS','CITE VILLE NOIRE, MAHEBOURG','CLAVET','CLEMENCIA','CLUNY','CONGOMAH','COROMANDEL','COTE D OR','COTTAGE','CREVE COEUR','CUREPIPE','CYBERCITY, EBENE','D EPINAY','DAGOTIERE','DOMAINE DES PAILLES','DUBREUIL','EAU COULEE , CUREPIPE','EBENE','ECROIGNARD','EMMANUEL ANQUETIL BUILD, PORT LOUIS','ERNEST FLORENT, BEL AIR','ESPERANCE, PITON','ESPERANCE, TREBUCHET','ESPERANCE, QUARTIER MILITAIRE','F.U.E.L','FERNEY','FLACQ','FLIC EN FLAC','FLOREAL','FOND DU SAC','FOREST SIDE','G. R. S.E','G.R.N.W ,PORT LOUIS','GENTILLY, MOKA','GEOFFROY BAMBOUS','GLENPARK VACOAS','GOKOOLA','GOODLANDS','GRAND BAIE','GRAND BEL AIR , MAHEBOURG','GRAND BOIS','GRAND GAUBE','GRAND PORT','GRAND SABLE','GRANDE RETRAITE, BON ACCEUIL','GRIS  GRIS, SOUILLAC','GROS BILLOT','GROS CAILLOUX','GUIBIES, PAILLES','HELVETIA, ST PIERRE','HENRIETTA','HERMITAGE','HIGHLANDS','HIGHLANDS, PHOENIX','HOLLYWOOD','ILE D,AMBRE','ILOT','ISIDORE ROSE, FLACQ','JUMBO, PHOENIX','KENYA','KOYRATTY','L AMITIE','L AGREMENT, ST PIERRE','L ASSURANCE DAGOTIERE','L ESCCALIER','L ESPARANCE, QUARTIER MILLITAIRE','L ASSURANCE','LA GAULLETTE','LA FLORA','LA PRAIRIE','LA TOUR KOENIG','LA BRASSERIE','LA CAVERNE','LA CROISEE, VALLEE DES PRETRES','LA CURE','LA FERME','LA FLORA','LA LAURA','LA LOUISE, QUATRE BORNES','LA LUCIE ROY, BEL AIR RIVIERE SECHE','LA MARIE','LA MIVOIE, RIVIERE NOIRE','LA NICOLIERE','LA NOURICE RD, OLIVIA','LA PAIX, PITON','LA PIPE','LA PORTE PROVIDENCE, POSTE DE FLACQ','LA PRENEUSE, RIVIERE NOIRE','LA ROSA, NEW GROVE','LA SOURCE','LA SOURDINE','LA TOUR KOENIG','LA fLORA','LAGREMENT, ST PIERRE','LALLMATIE','LAMITIE','LATAPIE, BON ACCUEIL','LAVENIR','LAVENTURE','LE  MORNE','LE BOUCHON','LE CHALAND','LE GOULET, TOMBEAU BAY','LE HOCHET, TERRE ROUGE','LE MORNE','LES CASERNES, CUREPIPE','LESUR, SEBASTOPOL','LOWER D AGOTIERE','LOWER VALE','MADAME LOLO, ROSE BELLE','MAHEBOURG','MALINGA','MAPOU','MARE CHICOSE','MARE D ALBERT','MARE D AUSTRALIA','MARE LA CHAUX','MEDINE, BAMBOUS','MEDINE CAMP DE MASQUE','MELLVILLE, GRAND GAUBE','MELROSE, MONTAGNE BLANCHE','MELVILLE, GRAND GAUBE','MESNIL','MIDLANDS','MOKA','MON CHOISY','MON DESERT MON TRESOR','MON DESIR, VACOAS','MONGOUT','MONT ROCHES','MONT GOUT','MONT IDA','MONTAGNE ORY','MONTAGNE BLANCHE','MONTAGNE LONGUE','MORCELLMENT, SAINT ANDRE','NEW GROVE','NOTRE DAME','NOUVELLE  DECOUVERTE','NOUVELLE FRANCE','OLIVIA','PAILLES','PAILLOTTE','PALMA','PALMAR, QUATRE COCOS','PAMPLEMOUSSES','PAVILLON, CAP MALHEUREUX','PELLEGRIN, SEBASTOPOL','PEREYBERE','PETIT BEL AIR, MAHEBOURG','PETIT PAQUET, MONTAGNE BLANCHE','PETIT, PTE AUX PIMENTS','PETIT RAFFRAY','PETIT VERGER','PETIT VERGER, ST PIERRE','PETITE RIVIERE','PHOENIX','PITON','PLAINE DES PAPAYES','PLAINE DES ROCHES','PLAINE LAUZUN','PLAINE MAGNIEN','PLAISANCE','PLEIN BOIS','POINTE AUX  SABLES','POINTE AUX CANONNIERS','POINTE AUX FEUILLES','POINTE AUX PIMENTS','POINTE DES LASCARS','PONT BLANC','PONT COLVILLE','PONT PRASLIN','PORT LOUIS','POSTE DE FLACQ','POSTE LAFAYETTE','POUDRE D OR HAMLET','POUDRE D OR VILLAGE','PROVIDENCE','QUARTIER MILITAIRE','QUATRE BORNES','QUATRE COCOS','QUATRE SOEURS','QUEEN VICTORIA, FLACQ','REDUIT','RIAMBEL','RICHE MARE, CENTRE DE FLACQ','RICHELIEU','RIPAILLES','RIVIERE DES GALETS','RIVIERE DES ANGUILLES','RIVIERE DES CREOLES','RIVIERE DU POSTE','RIVIERE DU REMPART','RIVIERE NOIRE','ROCHE BOIS','ROCHE BRUNES','ROSE BELLE','ROSE HILL','SAINT AUBIN','SAINT HILAIRE','SAINT HUBERT','SAINT JULIEN DHOTMAN','SAINT JULIEN VILLAGE','SAINT PAUL','SAINTE CROIX','SAINTE PIERRE','SEBASTOPOL','SODNAC','SOLFERINO','SOREZE, PAILLES','SOTTISE, GRAND BAIE','SOUILLAC','SOUILLAC H E','ST ANTOINE, GOODLANDS','ST JEAN, QUATRE BORNES','ST URSULE, CENTRE DE FLACQ','STANLEY','SURINAM','TAMARIND','TERRE ROUGE','TRANQUEBAR','TRIANON','TRIOLET','TROU AUX BICHES','TROU AUX CERFS','TYACK','UNION FLACQ','UNION PARK','UNION VALE','UNITE CAMP DE MASQUE','UPPER  VALE','VACOAS','VALLEE DES PRETRES','VALLEE PITON','VALLETTA','VERDUN','VILLE BAGUE','VOLMAR','VUILLEMIN','WOOTON','YEMEN',];
    const userType = localStorage.getItem('userType');
const dateStr = localStorage.getItem('dob');
if (dateStr != null) {

    var yy = dateStr.substring(0, 2);
    var mm = dateStr.substring(2, 4);
    var dd = dateStr.substring(4, 6);
    if (yy > 24) {
        yy = '19' + yy;
    } else {
        yy = '20' + yy;
    }
    // localStorage.setItem('dob', dd + '-' + mm + '-' + yy);

}
const format = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~0123456789]/;

const useStyles = (theme) => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },

    cssLabel: {
        color: 'Gray',
    },
    input: {
        color: 'Blue',
    },

    cssOutlinedInput: {
        '&$cssFocused $notchedOutline': {
            borderColor: `${theme.palette.primary.main} !important`,
        },
    },

    cssFocused: {},

    notchedOutline: {
        borderWidth: '1px',
        borderColor: 'Gray !important',
    },
    select: {
        '&:before': {
            borderColor: 'Gray',
        },
        color: 'Blue',
    },
    icon: {
        fill: 'Gray',
    },
});



class Auth extends Component {
    
    constructor(props) {
        super(props);
        const token = localStorage.getItem('Token');
        const kycdata = localStorage.getItem('kyc-data');
            console.log(localStorage.getItem('locality'))
        
        let loggedin = true;

        if (token == null) {
            loggedin = false;
        }
        this.state = {
         tokenStr:localStorage.getItem('Token'),
         locality:'',

            showproceedbtn: false,
            json_len: -1,
            loggedin,
            agentNumber: localStorage.getItem("AgentNumber"),
            cnt: 1,
            cli: 1,
            details: {
                firstName: '',//localStorage.getItem('fn'),
                lastName: '',//localStorage.getItem('ln'),
                gender: 'Male',
                date: '',//localStorage.getItem('dob'),
                cc: '',//localStorage.getItem('countryCode'),
                address:"",
                email: localStorage.getItem('email'),
                //accountType: 'Savings Account',
                //occupation: '',
                //mother: '',
                //place: '',
                nid: '',

            },
        };
        if(localStorage.getItem('contingency')!=null &&localStorage.getItem('contingency')=='true' ){
            this.state.tokenStr="T"+this.state.tokenStr;
        }
        this.hancli = this.hancli.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }
    handleChange(event) {
        var gen = event.target.value;
        this.setState((prevState) => ({
            details: {
                ...prevState.details,
                gender: gen,
            },
        }));
        console.log(this.state.details.date);
    }
    componentWillMount() {
        const data = localStorage.getItem('data');
        if (data) {
            this.setState(JSON.parse(data));
        }
        const date1 = new Date(parseInt(localStorage.getItem('date1'), 10));
        console.log(date1);
        localStorage.getItem('date1');
        if (localStorage.getItem('date1')) {
            this.setState((prevState) => ({
                details: {
                    ...prevState.details,
                    date: date1,
                },
            }));
        }
        // this.setState({ date: date1 });
    }

    componentDidUpdate() {
        //localStorage.setItem('data', JSON.stringify(this.state));
        //localStorage.setItem('date1', '' + this.state.details.date.getTime());
        //console.log(this.state.details.date);

    }
    mySubmitHandler = (event) => {
        event.preventDefault();
        let nam = this.state.details.address;
        let local = this.state.locality;
        /*let nam = this.state.details.address;
        let nam2 = this.state.details.email;
        let locality = this.state.details.locality;
        let email = this.state.details.email;
        let alternateNumber = this.state.details.alternateNumber;
        console.log(locality, email, alternateNumber);
        // let age = calculate_age(this.state.details.date);
        localStorage.setItem('address',localStorage.getItem('address')+" "+locality);
        localStorage.setItem('email', email);
        localStorage.setItem('alternateNumber', alternateNumber);*/
        let cnt = this.state.cnt;
        if (local == "") {
            alert("Enter the Locality");
        }
        else {
            const axios = require('axios');
            const qs = require('qs');

            let data = qs.stringify({
                'token': this.state.tokenStr,
                'address': localStorage.getItem('address')+" "+"locality "+localStorage.getItem('locality'),
                'alternateNumber': localStorage.getItem('alternativeNumber'),
                'email': localStorage.getItem('email')
            });
    
            let config = {
                method: 'put',
                maxBodyLength: Infinity,
                url: 'https://ekyc.chili.mu:9443/api/processAddress',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                data: data
            };
    
            axios.request(config)
                .then((response) => {
                    this.UpdateAddress()
                    this.state.showproceedbtn = true
                    console.log("Addressresponse", response);
                    // window.location.replace('/success')

                })
                .catch((error) => {
                    this.UpdateAddress()
                    
                });
    
        }

    };

   UpdateAddress(){
    // const req = axios.get("https://ekyc.chili.mu:9443/api/address/customer/"+this.state.tokenStr+"?address="+localStorage.getItem('address')+" "+"locality "+localStorage.getItem('locality'),
    const req = axios.get("https://ekyc.chili.mu:9443/api/address/customer/"+this.state.tokenStr+"?address="+localStorage.getItem('address')+" "+"locality "+localStorage.getItem('locality')+
    "&email="+localStorage.getItem('email')+"&alternateNumber="+localStorage.getItem('alternativeNumber'),
            {
                headers: { 'Content-Type': 'application/json' }
            }).then((res) => {
                window.location.replace('/success') 
                
                
            }).catch((error) => {
                console.log(error);
            });
               }

    hancli() {
        let cli = this.state.cli;
        cli = cli + 1;
        this.setState({ cli: cli });
    }
    myChangeHandler = (event) => {


        let nam = event.target.name;
        let val = event.target.value;
        console.log(nam,val);
        this.setState((prevState) => ({
            details: {
                ...prevState.details,
                [nam]: val,
            },
        }));
        if (nam == 'address') {

            localStorage.setItem('address', val)
        }
        if (nam == 'email') {

            localStorage.setItem("email", val)

        }
        /*if (nam == 'locality') {

            localStorage.setItem('address', localStorage.getItem('address')+" "+val);

        }*/






    };
    render() {
        // console.log(this.state.age);
        if (this.state.loggedin === false) {
            return <Redirect to="/"></Redirect>;
        }
        const { classes } = this.props;
        return (
            <React.Fragment>
                <div className="Auth-container">
                    {
                        this.state.agentNumber == null || this.state.agentNumber.trim().length == 0 ?
                            null
                            : <div style={{ marginTop: -50, textAlign: 'center' }}>
                                <label><strong>Agent Number:{this.state.agentNumber}</strong></label>
                                <Link to="/logout" style={{ textAlign: 'end', marginLeft: 20, color: 'black' }}>Logout</Link>
                                <br></br>
                            </div>
                    }

                    <h4 style={{ color: '#f049ac' }}>
                        Please Validate Your Information
                    </h4>

                    <form onSubmit={this.mySubmitHandler}>

                        <br></br>

                        <div
                            style={{
                                textAlign: 'left',
                                color: 'blue',
                                marginLeft: -5,
                                marginTop: -10,
                                marginBottom: 40,
                            }}
                        >
                            <h6 style={{ backgroundColor: 'gray', color: 'white' }}>
                                OTHER DETAILS
                            </h6>
                        </div>

                        <TextField
                            
                            name="address"
                            id="outlined-required"
                            label={<div style={{ color: 'black' }}> * Enter Address</div>}
                            variant="outlined"
                            onChange={this.myChangeHandler}
                            value={this.state.details.address}
                            InputLabelProps={{
                                classes: {
                                    root: classes.cssLabel,
                                    focused: classes.cssFocused,
                                },
                            }}
                            InputProps={{
                                classes: {
                                    input: classes.input,
                                    root: classes.cssOutlinedInput,
                                    focused: classes.cssFocused,
                                    notchedOutline: classes.notchedOutline,
                                },
                            }}
                        /><br></br>
                        
                            <div style={{  marginTop: 10 }}>
                            
                            <Autocomplete
                                style={{ width: 300 }}
                                freeSolo
                                filterOptions={filterOptions}
                                options={myOptions}
                                onChange={(event, value) => {
                                    this.setState({locality:value})
                                    console.log( "locality value===>",value)
                                    localStorage.setItem('locality', value)}} 
                                renderInput={(params) => (
                                    
                                    <TextField {...params}
                                        variant="outlined"
                                        name="locality"
                                        value={this.state.locality}
                                        
                                        label={<div style={{ color: 'black' }}>* Choose Locality</div>}
                                    />
                                )}
                            />
                        </div>
                        
                         
                        <sub style={{ color: "red" }}>*Please ensure that the address provided is as per the address proof document attached.</sub>
                        <br></br>
                        <br></br>


                        <TextField
                            name="email"
                            type='email'
                            id="outlined-required"
                            label={<div style={{ color: 'black' }}>Email</div>}
                            InputLabelProps={{
                                classes: {
                                    root: classes.cssLabel,
                                    focused: classes.cssFocused,
                                },
                            }}
                            InputProps={{
                                classes: {
                                    input: classes.input,
                                    root: classes.cssOutlinedInput,
                                    focused: classes.cssFocused,
                                    notchedOutline: classes.notchedOutline,
                                },
                            }}
                            variant="outlined"
                            onChange={this.myChangeHandler}
                        // value={this.state.details.email}
                        />
                        <br></br>
                        <br></br>
                        <TextField

                            name="Alternativenumber"
                            type="tel"
                            id="outlined-required"
                            label={<div style={{ color: 'black' }}>Alternative Number</div>}
                            variant="outlined"
                            inputProps={{ maxLength: 8 }}
                            onChange={(e) => { (localStorage.setItem('alternativeNumber', e.target.value)) }}

                        />
                        <br></br>
                        <br></br>
                       
                        

                        {this.state.details.address == null || this.state.details.address.trim().length == 0 || this.state.details.address == "undefined" ?                                                                                                             
                          null
                            : 
                            <button
                                className="button"
                                onClick={this.mySubmitHandler}
                                style={{
                                    marginLeft: 52,
                                    width: 150,
                                    textAlign: 'center',
                                    fontSize: 15,
                                }}

                            >
                                    Save and Continue

                                {/* <Link
                                    to="/success"
                                    className="link1"

                                >
                                    Save and Continue
                                </Link> */}
                            </button>}







                        {/* <button
                            className="button"
                            onClick={this.mySubmitHandler}
                            style={{
                                marginLeft: 52,
                                width: 150,
                                textAlign: 'center',
                                fontSize: 15,
                            }}
                        >
                            
                            <Link
                                to="/success"
                                className="link1"
                            >
                                Save and Continue
                            </Link>
                        </button> */}

                        {/* <Link to="/selfie">
                            <button className="button">Next Page</button>
                        </Link> */}
                    </form>
                    <Bottomstrip></Bottomstrip>
                </div>
            </React.Fragment>
        );
    }
}
Auth.propTypes = {
    classes: PropTypes.object.isRequired,
};
export default withStyles(useStyles)(Auth);
